import { Box, Grid, Heading, Icon, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { TbClock24, TbClockBolt } from "react-icons/tb";
import { GiWallet } from "react-icons/gi";
import { BsCreditCard2FrontFill } from "react-icons/bs";

const Features = () => {
  const featuresArray = [
    {
      icon: <TbClock24 />,
      title: "24/7 Availability",
      description: "Always here to support you, no matter the hour",
    },
    {
      icon: <GiWallet />,
      title: "Affordable Pricing",
      description: "Flexible plans designed to suit every budget.",
    },
    {
      icon: <TbClockBolt />,
      title: "Time-Saving",
      description: "Get your work done from the comfort of your home.",
    },
    {
      icon: <BsCreditCard2FrontFill />,
      title: "Easy Payment Options",
      description: "Multiple payment methods for seamless transactions.",
    },
  ];

  return (
    <>
      <Box w="full" my={20} py={10} bgColor="#fceeee">
        <Stack textAlign="center" pb={{ base: "20", md: "20" }}>
          <Heading as="h6" size="xs" letterSpacing="4px">
            WHY CHOOSE US
          </Heading>
          <Heading as="h6" fontSize={{ base: "2xl", md: "4xl" }}>
            Special Features We’re Proud Of
          </Heading>
        </Stack>
        <Grid
          templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(4, 1fr)" }}
          gap={{ base: "5", md: "5", lg: "16" }}
          px={{ base: "5", md: "10", lg: "20" }}
        >
          {featuresArray.map((feature) => (
            <Stack textAlign="center" alignItems="center" gap={3}>
              <Icon boxSize={12}>{feature.icon}</Icon>
              <Text
                lineClamp={1}
                fontSize={{ base: "md", md: "xl", lg: "2xl" }}
                fontWeight="semibold"
              >
                {feature.title}
              </Text>
              <Text color="black" fontSize={{ base: "xs", md: "md" }}>
                {feature.description}
              </Text>
            </Stack>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default Features;
